module.exports = __webpack_public_path__ + "static/media/key-events-services-icon.06e9fc6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/key-events-services-icon.svg
// module id = 883
// module chunks = 0